import React, { useState } from "react";
import { iconImages } from "../../../shared/cardIcons";
import Button from "@mui/material/Button";
import { Edit as IconEdit } from "@mui/icons-material";
import "../../../assets/styles/PaymentMethod.scss";
import UpdateCreditCard from "./UpdateCreditCard";

export default function PaymentMethod(props) {
  const [paymentMethod, setPaymentMethod] = useState(props.paymentMethod);
  const [formVisible, setFormVisible] = useState(false);

  if (!paymentMethod) {
    return '';
  }

  const handleUpdate = (newPaymentMethod) => {
    setFormVisible(false);
    setPaymentMethod(newPaymentMethod);
    props.onUpdate();
  };

  return (
    <div className="PaymentMethod">
      {!formVisible && (
        <div className="PaymentMethod--card-box">
          <div className="PaymentMethod--card-info">
            <span className="PaymentMethod--icon">
              {iconImages[paymentMethod.brand.toLowerCase()]}
            </span>
            <div className="PaymentMethod--card-details">
              <span className="PaymentMethod--last4">
                •••• {paymentMethod.last4}
              </span>
              <span className="PaymentMethod--expires">
                Expires {paymentMethod.exp_month}/{paymentMethod.exp_year}
              </span>
            </div>
          </div>
          <div className="PaymentMethod--action">
            <Button
              startIcon={<IconEdit />}
              onClick={() => setFormVisible(true)}
              color="primary"
              variant="outlined"
              size="small"
            >
              Update Card
            </Button>
          </div>
        </div>
      )}
      {formVisible && (
        <div className="PaymentMethod--update-form">
          <UpdateCreditCard
            onCancel={() => setFormVisible(false)}
            onUpdate={handleUpdate}
          />
        </div>
      )}
    </div>
  );
}
